class API {
    constructor() {
        this._url = 'https://ratonera.net/api';
        this.headers = {
            'Content-Type': 'application/json',
        };

        this.cache = {};
        this.cachetime = 10 * 60 * 1000; // 10 minutes
        this.inflight = {};

        if (localStorage.getItem('token')) {
            this.token = localStorage.getItem('token');
            this.headers['Authorization'] = `Bearer ${this.token}`;
        } else {
            this.token = null;
        }
    }

    clearCache(path = null) {
        if (path) {
            delete this.cache[path];
            return;
        }
        this.cache = {};
    }



    setToken(token) {
        if (!token) {
            return console.error('No token provided');
        }

        this.token = token;
        this.headers['Authorization'] = `Bearer ${this.token}`;
    }

    removeToken() {
        this.token = null;
        delete this.headers['Authorization'];
    }

    async request(method, path = null, data = {}, { cache = false } = {}) {
        console.log('api caching is', this.cache);
        if (!path) {
            console.error('No path provided');
            return
        }
        if (['GET', 'POST', 'PUT', 'DELETE'].indexOf(method) === -1) {
            console.error('Invalid method');
            return;
        }

        if (cache && method === 'GET') {
            const cached = this.cache[path];
            if (cached && (Date.now() - cached.timestamp < this.cachetime)) {
                return cached.data;
            }
        }

        switch (method) {
            case 'GET':
                return this.get(path, { cache });
            case 'POST':
                return this.post(path, data);
            case 'PUT':
                return this.put(path, data);
            case 'DELETE':
                return this.delete(path);
            default:
                console.error('Invalid method');
        }

    }

    async ret(response, args = {}) {
        const silent = args.silent || false;

        if (!response.ok) {
            return { error: response.status, message: response.statusText };
        }

        const data = await response.json();
        if (data && data.error) {
            console.error(data);
            if (!silent) {
                alert(data.error);
            }
            return data;
        }
        return data;
    }

    async get(path = null, args = {}) {
        if (!path) {
            console.error('No path provided')
            return;
        }

        if (args.raw !== true && this.inflight[path]) {
            return this.inflight[path];
        }

        const promise = fetch(`${this._url}${path}`, {
            method: 'GET',
            headers: this.headers,
        }).then(async (response) => {
            delete this.inflight[path];

            if (args.raw === true) {
                return response;
            }

            const data = await this.ret(response, args);
            this.cache[path] = { timestamp: Date.now(), data };
            return data;
        }).catch((err) => {
            delete this.inflight[path];
            throw err;
        });

        if (args.raw !== true) {
            this.inflight[path] = promise;
        }

        return promise;
    }

    async post(path = null, data = {}, args = {}) {
        const response = await fetch(`${this._url}${path}`, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(data),
        });

        if (args.raw === true) {
            return response;
        }

        return this.ret(response, args);
    }

    async postFormData(path = null, data = {}, args = {}) {
        const formData = new FormData();
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                formData.append(key, data[key]);
            }
        }

        const headers = new Headers();
        headers.append("Authorization", this.headers["Authorization"]);

        const response = await fetch(`${this._url}${path}`, {
            method: "POST",
            headers: headers,
            body: formData,
        });

        return response;
    }

    async delete(path = null, args = {}) {
        const response = await fetch(`${this._url}${path}`, {
            method: 'DELETE',
            headers: this.headers,
            // headers: this.headers,,
        });
        return this.ret(response, args);
    }

    async put(path = null, data = {}, args = {}) {
        const response = await fetch(`${this._url}${path}`, {
            method: 'PUT',
            headers: this.headers,
            // headers: this.headers,,
            body: JSON.stringify(data),
        });
        return this.ret(response, args);
    }
}

const api = new API();

export default api;